import { LyVariantChangedEventListener } from "./base"

if (!customElements.get('ly-main-product-media-preview-item-media-featured')) {
    customElements.define('ly-main-product-media-preview-item-media-featured', class extends LyVariantChangedEventListener {

        img = null
        sizes = [430, 814, 860, 1290]

        connectedCallback() {
            super.connectedCallback()

            this.img = this.querySelector('img')
        }

        disconnectedCallback() {
            super.disconnectedCallback()
        }

        _onVariantChange = ({ variantId }) => {
            const media = this._variantConfigs[variantId]
            if (!media) return
            this.img.src = `${media}&width=${this.sizes[0]}`
            this.img.srcset = this.sizes.map(width => `${media}&width=${width} ${width}w`).join(',')
        }
    })
}